import { useEffect, useState } from "react";
import { Nullable } from "../../../types/utils";
import * as Api from "../../api";
import { OrderCostingVersion, TApiOrderDetails } from "../../api/endpoints/Order";
import OrderHelpers from "../../utils/OrderHelpers";

const useOrderCostingVersion = (order?: Nullable<TApiOrderDetails>) => {
  const [orderCostingVersions, setOrderCostingVersions] = useState<Nullable<Array<OrderCostingVersion>>>(null);
  const [currentOrderCostingVersion, setCurrentOrderCostingVersion] = useState<Nullable<OrderCostingVersion>>(null);

  useEffect(() => {
    if (!order) {
      return;
    }

    Api.Order.costingVersions(order.id).then(versions => {
      setOrderCostingVersions(versions);

      const currentCostingVersion = OrderHelpers.currentOrderVersion(order, versions);

      setCurrentOrderCostingVersion(currentCostingVersion ?? null);
    }).catch(() => {
      setOrderCostingVersions([]);
      setCurrentOrderCostingVersion(  null);
    });
  }, [order?.id, order?.updated]);

  return {
    orderCostingVersions,
    currentOrderCostingVersion
  }
}

export default useOrderCostingVersion;
